module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1n3n6r-dab3a1dbd6c7d77c0723a36cfda232d2.svg";